import React, { useMemo } from 'react';
import NodeInfo from './NodeInfo';
const NodeInfoContainerPanel = ({ nodeMenuDetails, type, header }: any) => {
  const getNodeInfo = useMemo(() => {
    const nodeComponents = [];
    nodeMenuDetails.forEach((nodeMenuDetail) => {
      nodeComponents.push(
        <NodeInfo
          labelName={nodeMenuDetail.labelName}
          info={nodeMenuDetail.info}
          treeNodeType={type}
        />,
      );
    });
    return nodeComponents;
  }, [nodeMenuDetails]);

return (
    <div
      id="nodeinfocontainerpanel-wrapper"
      style={{ height: '80%', overflowX: 'hidden', overflowY: 'scroll' }}
    >
      <div id="nodeinfocontainerpanel-content" className="h-[34.5%]">
        <div
          id="nodeinfocontainerpanel-header-row"
          className="row"
          style={{ padding: '10px' }}
        >
          <div
            id={`nodeinfocontainerpanel-${header}-label`}
            className="nodeInfo nodeLabel col-6"
          >
            {header}
          </div>
        </div>
        <div id="nodeinfocontainerpanel-nodeinfo-list">{getNodeInfo}</div>
      </div>
    </div>
  );
};
export default NodeInfoContainerPanel;
